











import Vue from 'vue'

export default Vue.extend({
  name: 'HarvestModal',

  props: {
    /**
     * Sync prop to show and hide modal
     */
    showModal: {
      type: Boolean,
      default: false,
    },
    permaLink: {
      type: String,
      required: true,
    },
    entityName: {
      type: String,
      required: true,
    },
    itemTitle: {
      type: String,
      required: true,
    },
    itemId: {
      type: Number,
      required: true,
    },
    refNumber: {
      type: Number,
      required: true,
    },
  },

  computed: {
    visible: {
      get(): Boolean {
        return this.showModal
      },
      set(newValue: boolean) {
        this.$emit('update:showModal', newValue)
      },
    },
    harvestSrc(): String {
      return (
        'https://platform.harvestapp.com/platform/timer?app_name=DoneDone&closable=false&chromeless=true' +
        '&external_item_id=' +
        this.itemId +
        '&external_item_name=' +
        encodeURIComponent('#' + this.refNumber + ': ' + this.itemTitle) +
        '&default_project_name=' +
        encodeURIComponent(this.entityName) +
        '&permalink=' +
        encodeURIComponent(this.permaLink)
      )
    },
  },
})
